(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fg-cart-upsell"] && !Shopify.designMode) return;
  try {
    class SplashCartUpsell extends HTMLElement {
    cartSections = [
      {
        section: 'cart-drawer',
        childSelector: '#CartDrawer .drawer__inner',
        replacesSelector: '#CartDrawer .drawer__inner',
      },
      {
        section: 'cart-icon-bubble',
        childSelector: '.cart-count-bubble',
        replacesSelector: '#cart-icon-bubble .cart-count-bubble',
      },
    ];

    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelector('.splash-cart-upsell .atc-button').addEventListener('click', (event) => {
        this.handleAddToCart(event);
      });
    }

    async handleAddToCart(event) {
      const element = event.currentTarget;
      element.classList.add('loading');
      element.disabled = true;
      const data = {
        items: [
          {
            id: element.dataset.variantId,
            quantity: 1,
            properties: {
              _fg_widget_id: 'SPLASH-CART-UPSELL',
            },
          },
        ],
        sections: 'cart-drawer,cart-icon-bubble',
      };

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      element.classList.remove('loading');
      element.disabled = false;

      const domParser = new DOMParser();
      this.cartSections.forEach((config) => {
        const sectionElement = domParser
          .parseFromString(result.sections[config.section], 'text/html')
          .querySelector(config.childSelector);
        document.querySelector(config.replacesSelector).innerHTML = sectionElement.innerHTML;
      });
    }
  }
  customElements.define('splash-cart-upsell', SplashCartUpsell);
  } catch(e) { console.error(e); }
})();

})();
